//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Common = require('@/tbs/model/to/Common')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_Player = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Player.prototype = {
    'player-name-required': '请填写球员名称',
    'player-num-required': '请填写球员号码',
    'player-name-label': '球员名称',
    'player-name-placeholder': '球员名称',
    'player-logo-label': '球员照片',
    'player-logo-placeholder': '标准头像照，建议图片大小300X400 PX',
    'player-gender-label': '球员性别',
    'gender-option-1': '男',
    'gender-option-2': '女',
    'player-num-label': '球员号码',
    'player-num-placeholder': '0-99',
    'delete-player': '删除球员',
    'delete-player-confirm-message': '确认删除该球员，无法进行还原',
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Player, Common);

module.exports = tbs_model_to_Player